import { render, staticRenderFns } from "./formProposta_p4.vue?vue&type=template&id=6b82a3b9&scoped=true"
import script from "./formProposta_p4.vue?vue&type=script&lang=js"
export * from "./formProposta_p4.vue?vue&type=script&lang=js"
import style0 from "./formProposta_p4.vue?vue&type=style&index=0&id=6b82a3b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b82a3b9",
  null
  
)

export default component.exports